"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodsBannerService = void 0;
var apiRoutes_1 = require("../../utils/apiRoutes");
var Base_1 = require("../Base");
var PaymentMethodsBannerService = /** @class */ (function (_super) {
    __extends(PaymentMethodsBannerService, _super);
    function PaymentMethodsBannerService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentMethodsBannerService.prototype.fetchBannerSettings = function () {
        return this.request({
            url: (0, apiRoutes_1.paymentMethodsBannerSettingsApiUrl)(),
            method: 'get',
        });
    };
    return PaymentMethodsBannerService;
}(Base_1.BaseService));
exports.PaymentMethodsBannerService = PaymentMethodsBannerService;
//# sourceMappingURL=index.js.map